import {uniqBy} from 'lodash';
import api from './api';

/**
 * PurchaseOrders
 * GET     /api/v1/purchase-orders
 * GET     /api/v1/purchase-orders/{purchaseOrderId}
 *
 * SerialNumbers
 * GET     /api/v1/serials/{sysRowID}
 * GET     /api/v1/orders/{sysRowID}/serials
 *
 * PartNumbers
 * GET     /api/v1/part-numbers/{partNumberId}
 * GET     /api/v1/serial-numbers/{serialNumberId}/part-numbers
 */

const service = {
  searchByPurchaseOrderNumber: purchaseOrderNumber =>
    api.get(`search/by-order-number`, {"orderNumber": purchaseOrderNumber}),
  searchBySerialNumber: serialNumber =>
    api.get(`search/by-serial-number`, {"serialNumber": serialNumber}),
  searchByPartNumber: partNumber =>
    api.get(`search/by-part-number`, {"partNumber": encodeURIComponent(partNumber)}),
  fetchSerial: sysRowID => api.get(`serials/${sysRowID}`),
  fetchSerialsByPartNum: async partNum => {
    api.get(`parts/${encodeURIComponent(partNum)}/audit`);
    const {result} = await api.get(
      `parts/${encodeURIComponent(partNum)}/serials`
    );
    return uniqBy(result, 'sysRowID');
  },
  fetchOrders: () => api.get(`orders/`),
  fetchOrderPartSerials: (orderNum, partNum) =>
    api.get(`order/${orderNum}/parts/${encodeURIComponent(partNum)}/serials`),
  fetchPartsByOrderSysRowID: async sysRowID => {
    try {
      const {result: orderDetails} = await api.get(`orders/${sysRowID}`);
      const partsUrl = `orders/${orderDetails.orderNum}/parts`;
      const {result: parts} = await api.get(partsUrl);
      return {
        ...orderDetails,
        parts,
      };
    } catch (error) {
      throw new Error('Unable to fetch order details');
    }
  },
};

export default service;
